const triggerUpdateShowroomWebhook = async (wingsId) => {
    const myHeaders = new Headers();
    // No auth token needed as per CustomerPanelService pattern

    const formdata = new FormData();
    formdata.append("WingsId", wingsId);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    try {
        const response = await fetch(
            "https://n8nautomation.sasone.in/webhook/sashyundai/production/update-showroom-in-booking",
            requestOptions
        );
        const result = await response.json();
        console.log("Update Showroom Webhook Result:", result);
        // Return true if response is [{ success: true }]
        const success = Array.isArray(result) ? result[0]?.success === true : result?.message === "showroom updated";
        return success;
    } catch (error) {
        console.error("Update Showroom Webhook Error:", error);
        throw error;
    }
};

export default triggerUpdateShowroomWebhook;
